var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-menu-desktop"},[_c('AsideMenuLogo',{attrs:{"route":"prime"}}),_c('AsideMenuSkeleton',{attrs:{"is-loading":!_vm.isUserDataReady}},[_c('AsideMenu',{attrs:{"routes":_vm.routes}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }